import type { Profile } from '@/types';
import { ONE_CONTEXT_PROFILE_CONNECTION, ONE_CONTEXT_TENANT } from '@/utilities/constants';
import { PL_LOG_GROUPS, logger } from '@/utilities/logger';
import { LOG_LEVEL } from '@b2x/shared';
import { type ProfileState, getDispatchers, subscribe } from '@seamless/one-context';
import { initializeStore } from '@seamless/store';

export async function updateProfilePicture() {
  const store = initializeStore();

  store.subscribe('MMU-PROFILE', async (state) => {
    logger('MMU Changes', {
      args: [state],
      group: PL_LOG_GROUPS.PROFILE,
      level: LOG_LEVEL.INFO,
    });
    const mmuProfilePicture = state?.profilePicture?.data;
    const b2xProfileState = await getState(ONE_CONTEXT_TENANT, ONE_CONTEXT_PROFILE_CONNECTION);
    const b2xProfilePicture = (b2xProfileState.activeProfile as unknown as Profile).profilePicture;

    if (mmuProfilePicture !== b2xProfilePicture) {
      const { setProfileState } = await getDispatchers(ONE_CONTEXT_TENANT, ONE_CONTEXT_PROFILE_CONNECTION);
      const updatedAvailableProfiles = b2xProfileState.availableProfiles.map((profile) => {
        if (profile.id === b2xProfileState.activeProfile.id) {
          return {
            ...profile,
            profilePicture: mmuProfilePicture,
          };
        }
        return profile;
      });

      const updatedActiveProfile = {
        ...b2xProfileState.activeProfile,
        profilePicture: mmuProfilePicture,
      };

      const updatedProfileState = structuredClone({
        ...b2xProfileState,
        activeProfile: updatedActiveProfile,
        availableProfiles: updatedAvailableProfiles,
      });

      setProfileState(updatedProfileState);

      logger('Profile Picture updated', {
        args: [],
        group: PL_LOG_GROUPS.PROFILE,
        level: LOG_LEVEL.INFO,
      });
    }
  });
}

type AllowedConnections = 'ProfileConnection';

async function getState(tenant: string, componentName: AllowedConnections): Promise<ProfileState> {
  return new Promise((resolve) => {
    subscribe(componentName, {
      tenant,
      componentName,
      callback: (state: ProfileState) => resolve(structuredClone(state)),
    });
  });
}
